import React from "react";

import "./styles.scss";

export default class SectionHero extends React.Component {
  render() {
    const style = this.props.style;

    return (
      <div className={`sectionHero ${style}`}>
        <div className="container">
          <div className="verticalCenter">
            <div className="col">{this.props.children}</div>
          </div>
        </div>
      </div>
    );
  }
}
